export enum SortingTypes {
    'SORT_BY_LABEL' = 'sort_by',
    'SORT_TOP_RATED' = 'sort_top_rated',
    'SORT_PRICE_LOW_TO_HIGH' = 'sort_price_low_to_high',
    'SORT_PRICE_HIGH_TO_LOW' = 'sort_price_high_to_low',
    'PRODUCT_NAME_ASCENDING' = 'product_name_ascending',
    'PRODUCT_NAME_DESCENDING' = 'product_name_descending'
}
